import { createReducer } from '@cbgms/base/utils/redux'
const defaultState = {}

const cache = createReducer(defaultState, {})

export default cache
